export default "__VITE_ASSET__B0Sdcc9b__"